
import React, { useEffect, useState } from "react";

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Input,
  Label
} from "reactstrap";

import {
  getAds,
  addAd,
  updateAd,
  deleteAd
} from "../../services/api/api-service";


const Ads = () => {

  const [ads, setAds] = useState([]);

  const [title, setTitle] = useState("");

  const [image, setImage] = useState("");

  const [link, setLink] = useState("");

  // EDIT MODE
  const [editingId, setEditingId] = useState(null);


  // ==============================
  // LOAD ADS
  // ==============================

  const loadAds = async () => {

    try {

      const data = await getAds();

      setAds(data || []);

    } catch (error) {

      console.log("Error loading ads:", error);

    }

  };


  useEffect(() => {

    loadAds();

  }, []);


  // ==============================
  // ADD / UPDATE AD
  // ==============================

  const handleSaveAd = async () => {

    if (!image) {

      alert("Please enter Image URL");

      return;

    }


    const payload = {

      title,

      image,

      link,

      status: "active",

      date: new Date()

    };


    try {

      // ==========================
      // UPDATE EXISTING AD
      // ==========================

      if (editingId) {

        await updateAd(editingId, payload);

        alert("Ad updated successfully");

      }

      // ==========================
      // ADD NEW AD
      // ==========================

      else {

        await addAd(payload);

        alert("Ad added successfully");

      }


      // RESET FORM

      setTitle("");

      setImage("");

      setLink("");

      setEditingId(null);


      // RELOAD ADS

      loadAds();

    } catch (error) {

      console.log(
        "Save Ad Error:",
        error
      );

      alert(
        editingId
          ? "Failed to update ad"
          : "Failed to add ad"
      );

    }

  };


  // ==============================
  // EDIT AD
  // ==============================

  const handleEdit = (ad) => {

    setEditingId(ad.id);

    setTitle(ad.title || "");

    setImage(ad.image || "");

    setLink(ad.link || "");

    // Scroll page to top

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

  };


  // ==============================
  // CANCEL EDIT
  // ==============================

  const handleCancelEdit = () => {

    setEditingId(null);

    setTitle("");

    setImage("");

    setLink("");

  };


  // ==============================
  // DELETE AD
  // ==============================

  const handleDelete = async (id) => {

    try {

      await deleteAd(id);

      alert("Ad deleted");

      loadAds();

    } catch (error) {

      console.log(
        "Delete Error:",
        error
      );

    }

  };


  return (

    <Container fluid>

      {/* ==========================
          ADD / EDIT FORM
      =========================== */}

      <Row>

        <Col lg="12">

          <Card>

            <CardBody>

              <CardTitle>

                {editingId
                  ? "Edit Ad"
                  : "Manage Ads"}

              </CardTitle>


              {/* TITLE */}

              <Label>
                Ad Title
              </Label>

              <Input

                value={title}

                onChange={(e) =>
                  setTitle(e.target.value)
                }

                placeholder="Enter Ad Title"

              />


              <br />


              {/* IMAGE */}

              <Label>
                Ad Image URL
              </Label>

              <Input

                value={image}

                onChange={(e) =>
                  setImage(e.target.value)
                }

                placeholder="Enter Image URL"

              />


              <br />


              {/* LINK */}

              <Label>
                Redirect Link (Optional)
              </Label>

              <Input

                value={link}

                onChange={(e) =>
                  setLink(e.target.value)
                }

                placeholder="https://example.com"

              />


              <br />


              {/* SAVE BUTTON */}

              <Button
                color={
                  editingId
                    ? "success"
                    : "primary"
                }
                onClick={handleSaveAd}
              >

                {editingId
                  ? "Update Ad"
                  : "Add Ad"}

              </Button>


              {/* CANCEL BUTTON */}

              {editingId && (

                <Button
                  color="secondary"
                  className="ml-2"
                  onClick={handleCancelEdit}
                >

                  Cancel

                </Button>

              )}

            </CardBody>

          </Card>

        </Col>

      </Row>


      {/* ==========================
          ADS LIST
      =========================== */}

      <Row>

        {ads.map((ad) => (

          <Col
            lg="4"
            md="6"
            key={ad.id}
          >

            <Card>

              <CardBody>

                {/* IMAGE */}

                <img

                  src={ad.image}

                  alt={ad.title}

                  style={{
                    width: "100%",
                    height: 150,
                    objectFit: "cover"
                  }}

                />


                {/* TITLE */}

                <h5
                  style={{
                    marginTop: 10
                  }}
                >

                  {ad.title}

                </h5>


                {/* LINK */}

                <p
                  style={{
                    wordBreak: "break-all"
                  }}
                >

                  {ad.link
                    ? ad.link
                    : "No redirect link"}

                </p>


                {/* EDIT */}

                <Button

                  color="warning"

                  className="mr-2"

                  onClick={() =>
                    handleEdit(ad)
                  }

                >

                  Edit

                </Button>


                {/* DELETE */}

                <Button

                  color="danger"

                  onClick={() =>
                    handleDelete(ad.id)
                  }

                >

                  Delete

                </Button>


              </CardBody>

            </Card>

          </Col>

        ))}

      </Row>

    </Container>

  );

};


export default Ads;
